import { render, staticRenderFns } from "./trainingsHubTour.vue?vue&type=template&id=a39b2ad6&scoped=true"
import script from "./trainingsHubTour.vue?vue&type=script&lang=js"
export * from "./trainingsHubTour.vue?vue&type=script&lang=js"
import style0 from "./trainingsHubTour.vue?vue&type=style&index=0&id=a39b2ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39b2ad6",
  null
  
)

export default component.exports